"use strict";

exports.__esModule = true;
exports.ComponentRemainingLifeElement = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _polished = require("polished");
var _Core = require("../../Core");
var _Translator = require("../../Core/Translator");
var _common = require("../common");
var _getFilteredPlanData = require("./getFilteredPlanData");
var _DevicePlans = require("../../DevicePlans");
var _Device = require("../../Device");
var _Time = require("../../Time");
var _Theme = require("../../Theme");
var _TileContext = require("../common/TileContext");
var _stateEdge = require("../common/stateEdge");
var _Utils = require("../../../Utils");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
// Below these the card drops its chip, then its stat labels, so the figures
// keep room on a small tile.
var COMPACT_HEIGHT = 150;
var TINY_HEIGHT = 96;
var PAD_X = 16;
var PAD_TOP = 10;
var PAD_BOTTOM = 12;
var STATS_GAP_Y = 8;
var LABEL_HEIGHT = 14;
var STAT_COLUMN_WIDTH = 150;
var safeMix = function safeMix(amount, color, base) {
  try {
    return (0, _polished.mix)(amount, color, base);
  } catch (e) {
    return base;
  }
};
var Card = _styledComponents["default"].div.withConfig({
  displayName: "ComponentRemainingLifeElementmodern__Card",
  componentId: "sc-1mot5yx-0"
})(["position:relative;box-sizing:border-box;overflow:hidden;display:flex;flex-direction:column;background:#ffffff;border-radius:12px;box-shadow:", ";color:#1b2227;"], (0, _Theme.val)("CardShadow"));

// The state edge along the top: the same rule as device cards and rows.
var Edge = _styledComponents["default"].div.withConfig({
  displayName: "ComponentRemainingLifeElementmodern__Edge",
  componentId: "sc-1mot5yx-1"
})(["flex:none;"]);
var Body = _styledComponents["default"].div.withConfig({
  displayName: "ComponentRemainingLifeElementmodern__Body",
  componentId: "sc-1mot5yx-2"
})(["flex:1;min-height:0;display:flex;flex-direction:column;padding:10px ", "px 12px;"], PAD_X);
var Header = _styledComponents["default"].div.withConfig({
  displayName: "ComponentRemainingLifeElementmodern__Header",
  componentId: "sc-1mot5yx-3"
})(["flex:none;display:flex;align-items:center;gap:10px;min-width:0;"]);
var Name = _styledComponents["default"].div.withConfig({
  displayName: "ComponentRemainingLifeElementmodern__Name",
  componentId: "sc-1mot5yx-4"
})(["flex:1 1 auto;min-width:0;font-family:", ";font-weight:700;letter-spacing:-0.02em;line-height:1.15;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"], _TileContext.FLAT_FONT_HEADING);
var Chip = _styledComponents["default"].span.withConfig({
  displayName: "ComponentRemainingLifeElementmodern__Chip",
  componentId: "sc-1mot5yx-5"
})(["flex:none;font-size:10.5px;font-weight:700;letter-spacing:0.06em;text-transform:uppercase;padding:3px 8px;border-radius:6px;white-space:nowrap;"]);
var Stats = _styledComponents["default"].div.withConfig({
  displayName: "ComponentRemainingLifeElementmodern__Stats",
  componentId: "sc-1mot5yx-6"
})(["flex:1;min-height:0;margin-top:auto;padding-top:", "px;display:grid;gap:", "px 14px;align-content:start;overflow:hidden;"], STATS_GAP_Y, STATS_GAP_Y);
var Stat = _styledComponents["default"].div.withConfig({
  displayName: "ComponentRemainingLifeElementmodern__Stat",
  componentId: "sc-1mot5yx-7"
})(["min-width:0;"]);
var Label = _styledComponents["default"].div.withConfig({
  displayName: "ComponentRemainingLifeElementmodern__Label",
  componentId: "sc-1mot5yx-8"
})(["font-size:10px;font-weight:700;letter-spacing:0.08em;text-transform:uppercase;color:#7c8a94;line-height:1.2;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"]);
var Value = _styledComponents["default"].div.withConfig({
  displayName: "ComponentRemainingLifeElementmodern__Value",
  componentId: "sc-1mot5yx-9"
})(["margin-top:2px;font-family:", ";font-weight:700;line-height:1.15;font-variant-numeric:tabular-nums;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"], _TileContext.FLAT_FONT_MONO);
var Empty = _styledComponents["default"].div.withConfig({
  displayName: "ComponentRemainingLifeElementmodern__Empty",
  componentId: "sc-1mot5yx-10"
})(["display:flex;align-items:center;justify-content:center;text-align:center;padding:0 ", "px;font-size:12.5px;color:#7c8a94;"], PAD_X);
var formatDate = function formatDate(date, timezoneName) {
  return _momentTimezone["default"].utc(date).tz(timezoneName).format("ll");
};

// What the colour says, in words, for the chip.
var statusLabel = function statusLabel(planData, translate) {
  if (planData.activityState === "Pending") {
    return translate("ComponentRemainingLife.status.due", "Maintenance due");
  }
  if (planData.remainingLife < 10) {
    return translate("ComponentRemainingLife.status.critical", "Critical");
  }
  if (planData.remainingLife < 20) {
    return translate("ComponentRemainingLife.status.soon", "Due soon");
  }
  return translate("ComponentRemainingLife.status.healthy", "Healthy");
};

/**
 * The plan nearest to its maintenance threshold for a device, as a card: the
 * state colour along the top edge and in a chip, the plan name, and the
 * figures as labelled stat tiles. Same data path as the legacy element.
 */
var ComponentRemainingLifeElement = exports.ComponentRemainingLifeElement = function ComponentRemainingLifeElement(props) {
  var hidePlanName = props.hidePlanName,
    hideCumulativeUsage = props.hideCumulativeUsage,
    hideRemainingLife = props.hideRemainingLife,
    hideLastClosedMaintenanceDate = props.hideLastClosedMaintenanceDate,
    hideMaintenancePredictedOrDueDate = props.hideMaintenancePredictedOrDueDate,
    width = props.width,
    height = props.height,
    fontSize = props.fontSize;
  var _React$useContext = _react["default"].useContext(_DevicePlans.DevicePlansContext),
    getDevicePlansData = _React$useContext.getDevicePlansData;
  var device = _react["default"].useContext(_Device.DeviceContext);
  var _React$useContext2 = _react["default"].useContext(_Time.TimeContext),
    timezone = _React$useContext2.timezone;
  var _React$useContext3 = _react["default"].useContext(_Time.ReportingPeriodContext),
    name = _React$useContext3.name;
  var _React$useContext4 = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext4.translate;
  var theme = _react["default"].useContext(_styledComponents.ThemeContext) || {};
  // Inside a device card the card itself is drawn by the grid: no chrome and
  // no second state edge, just the content.
  var inDeviceCard = _react["default"].useContext(_TileContext.DeviceCardContext) === true;
  var compact = height < COMPACT_HEIGHT;
  var tiny = height < TINY_HEIGHT;
  var valueSize = Math.min(fontSize || 20, compact ? 16 : 20);
  var nameSize = compact ? 14 : 17;
  var padX = inDeviceCard ? 6 : PAD_X;
  var edgeHeight = inDeviceCard ? 0 : (0, _stateEdge.stateEdgeSize)(width);
  var chrome = inDeviceCard ? {
    background: "transparent",
    boxShadow: "none",
    borderRadius: 0
  } : undefined;

  // Only the stats that fit, by importance, so nothing overflows the card.
  var statHeight = (tiny ? 0 : LABEL_HEIGHT) + Math.ceil(valueSize * 1.15);
  var headerHeight = Math.ceil(nameSize * 1.15) + 4;
  var roomForStats = height - edgeHeight - PAD_TOP - PAD_BOTTOM - headerHeight - STATS_GAP_Y;
  var rows = Math.max(1, Math.floor((roomForStats + STATS_GAP_Y) / (statHeight + STATS_GAP_Y)));
  var columns = Math.max(1, Math.min(4, Math.floor((width - 2 * padX) / STAT_COLUMN_WIDTH)));
  return /*#__PURE__*/_react["default"].createElement(_Core.AsyncLoader, {
    load: getDevicePlansData,
    params: device.uuid,
    key: name
  }, function (loaderProps) {
    return /*#__PURE__*/_react["default"].createElement(_Core.LoadingMediator, loaderProps, function (data) {
      var position = (0, _common.getWidgetPositionProps)(props);
      if (data.length === 0) {
        return /*#__PURE__*/_react["default"].createElement(Card, _extends({
          style: Object.assign({}, position, chrome)
        }, (0, _common.getWidgetInteractionProps)(props), {
          "data-testid": "ComponentRemainingLifeNoDataText"
        }), /*#__PURE__*/_react["default"].createElement(Empty, {
          style: {
            flex: 1
          }
        }, translate("ComponentRemainingLife.NoData.HelperText", "No plans exist for this device")));
      }
      var planData = (0, _getFilteredPlanData.getFilteredPlanData)(data);
      var planName = planData.planName,
        remainingLife = planData.remainingLife,
        threshold = planData.threshold,
        currentValue = planData.currentValue;
      var color = theme[(0, _getFilteredPlanData.getBackgroundColor)(remainingLife)] || "#c7cfd5";
      var pending = planData.activityState === "Pending";
      var stats = [!hideRemainingLife && {
        key: "remaining",
        label: translate("ComponentRemainingLife.RemainingLife.Label", "Remaining Life"),
        value: threshold !== 0 ? Math.round(remainingLife) + " %" : "–",
        testId: "ComponentRemainingLife.RemainingLife"
      }, !hideMaintenancePredictedOrDueDate && {
        key: "date",
        label: pending ? translate("ComponentRemainingLife.MaintenancePending.dueSince", "Due since") : translate("ComponentRemainingLife.MaintenancePending.predicted", "Predicted"),
        value: pending ? planData.pendingAt ? formatDate(planData.pendingAt, timezone.name) : "–" : planData.expectedAt ? formatDate(planData.expectedAt, timezone.name) : "–",
        testId: "ComponentRemainingLife.MaintenancePredictedOrDueDate"
      }, !hideCumulativeUsage && {
        key: "usage",
        label: translate("ComponentRemainingLife.CumulativeUsage.shortLabel", "Usage since last task"),
        value: (0, _Utils.formatDuration)(currentValue)
      }, !hideLastClosedMaintenanceDate && {
        key: "closed",
        label: translate("ComponentRemainingLife.LastClosedMaintenanceDate.shortLabel", "Last task closed"),
        value: planData.lastActivityClosedDate ? formatDate(planData.lastActivityClosedDate, timezone.name) : "–",
        testId: "ComponentRemainingLife.LastClosedMaintenanceDate"
      }].filter(Boolean).slice(0, rows * columns);
      return /*#__PURE__*/_react["default"].createElement(Card, _extends({
        style: Object.assign({}, position, chrome)
      }, (0, _common.getWidgetInteractionProps)(props), {
        "data-testid": "ComponentRemainingLife"
      }), edgeHeight > 0 && /*#__PURE__*/_react["default"].createElement(Edge, {
        style: {
          height: edgeHeight,
          background: color
        }
      }), /*#__PURE__*/_react["default"].createElement(Body, {
        style: {
          padding: PAD_TOP + "px " + padX + "px " + PAD_BOTTOM + "px"
        }
      }, (!hidePlanName || !tiny) && /*#__PURE__*/_react["default"].createElement(Header, null, !hidePlanName && /*#__PURE__*/_react["default"].createElement(Name, {
        style: {
          fontSize: nameSize
        },
        title: planName
      }, planName), !tiny && width >= 220 && /*#__PURE__*/_react["default"].createElement(Chip, {
        style: {
          background: safeMix(0.82, "#ffffff", color),
          color: safeMix(0.45, "#1b2227", color),
          marginLeft: hidePlanName ? 0 : undefined
        }
      }, statusLabel(planData, translate))), stats.length > 0 && /*#__PURE__*/_react["default"].createElement(Stats, {
        style: {
          gridTemplateColumns: "repeat(" + Math.min(columns, stats.length) + ", minmax(0, 1fr))"
        }
      }, stats.map(function (stat) {
        return /*#__PURE__*/_react["default"].createElement(Stat, {
          key: stat.key
        }, !tiny && /*#__PURE__*/_react["default"].createElement(Label, null, stat.label), /*#__PURE__*/_react["default"].createElement(Value, {
          style: {
            fontSize: valueSize
          },
          "data-testid": stat.testId
        }, stat.value));
      }))));
    });
  });
};